import { Input } from "components/shared/FormComponents";
import Loader from "components/shared/Loader";
import SaveChangesButton from "components/shared/SaveChangesButton";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { editSection, getSection } from "store/actions";

const EditLocation = () => {
  const { locationSlug } = useParams();
  const { loading, error, section } = useSelector((state) => state.section);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getSection({
        page: "locations",
        slug: locationSlug,
      })
    );
  }, [locationSlug, dispatch]);

  useEffect(() => {
    reset({
      locationTitle: section?.locationTitle,
    });
  }, [reset, section]);

  const onSubmit = (data) => {
    dispatch(
      editSection({
        slug: locationSlug,
        page: "locations",
        data: { section: data },
        navigate,
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <div className="acc-form">
      <div className="card">
        <div className="card-head">
          <h4>
            <FormattedMessage id={"edit-location"} />
          </h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <Col xs={12}>
              <Row>
                <Col lg={6} xs={12}>
                  <Input
                    langId="title"
                    name="locationTitle.ar"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Input
                    langId="title"
                    name="locationTitle.en"
                    register={register}
                    errors={errors}
                  />
                </Col>
              </Row>

              <SaveChangesButton />
            </Col>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditLocation;
